import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminLead2Detail from '../Admin/AdminLead2Detail';
import AgentLayout from './AgentLayout';
import { useAgentAuth } from '../../contexts/AgentAuthContext';
import { Leads2PortalProvider } from '../../contexts/Leads2PortalContext';

const AgentLead2DetailPage = () => {
  const { agentToken, agentUser } = useAgentAuth();
  if (!agentToken || !agentUser) return <Navigate to="/agent/login" replace />;
  const value = {
    token: agentToken,
    role: 'agent',
    basePath: '/agent/leads2',
    currentUserId: agentUser?.id || null,
    currentUserName: `${agentUser.firstName || ''} ${agentUser.lastName || ''}`.trim(),
    Layout: AgentLayout,
  };
  return (
    <Leads2PortalProvider value={value}>
      <AdminLead2Detail />
    </Leads2PortalProvider>
  );
};

export default AgentLead2DetailPage;
